import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f6b4d8b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tree-select"
};
const _hoisted_2 = {
  key: 0,
  class: "tree-title"
};
const _hoisted_3 = {
  class: "tree-input"
};
import { ref, computed, watch, onMounted, nextTick } from 'vue';
const __default__ = {
  name: 'treeSelect'
};
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    defaultProps: {
      type: Object,
      default: {}
    },
    data: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ''
    },
    treeProps: {
      type: Object,
      default: () => ({
        value: 'id',
        label: 'label',
        children: 'children'
      })
    },
    placeholder: {
      type: String,
      default: '请输入地区名称'
    },
    // 树形数据
    treeData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    // 是否默认展开全部，默认值true
    defaultExpand: {
      type: Boolean,
      default: true
    },
    // 是否在点击节点的时候展开节点
    expandOnClickNode: {
      type: Boolean,
      default: false
    },
    // 是否默认选中某个节点
    defaultClickNode: {
      type: String || Number,
      default: ''
    },
    defaultExendNode: {
      type: String,
      default: ''
    },
    defaultCheckedKeys: {
      type: String,
      default: ''
    },
    //默认选中
    defaultCheckNode: {
      type: Array,
      default: function () {
        return [];
      }
    },
    nodeKey: {
      type: String,
      default: () => {
        return 'name';
      }
    },
    currentNodeKey: {
      type: String,
      default: () => {
        return '';
      }
    }
  },
  emits: ['handleNodeClick'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    let scroll = ref(0);
    const getKey = (prefix, id) => {
      return `${prefix}-${id}`;
    };
    const createData = (maxDeep, maxChildren, minNodesNumber, deep = 1, key = 'node') => {
      let id = 0;
      return Array.from({
        length: minNodesNumber
      }).fill(deep).map(() => {
        const childrenNumber = deep === maxDeep ? 0 : Math.round(window.crypto.getRandomValues(new Uint8Array(1)) * 0.001 * maxChildren);
        const nodeKey = getKey(key, ++id);
        return {
          id: nodeKey,
          label: nodeKey,
          children: childrenNumber ? createData(maxDeep, maxChildren, childrenNumber, deep + 1, nodeKey) : undefined
        };
      });
    };
    const query = ref('');
    const treeRef = ref();
    // const data = createData(3, 10, 5)

    const onQueryChanged = query => {
      // TODO: fix typing when refactor tree-v2
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      treeRef.value.filter(query);
    };
    const filterMethod = (query, node) => {
      return node.label.includes(query);
    };

    // 筛选节点
    const filterNode = (value, data, node) => {
      if (!value) return true;
      let parentNode = node.parent;
      let labels = [node.label];
      let level = 1;
      while (level < node.level) {
        labels = [...labels, parentNode.label];
        parentNode = parentNode.parent;
        level++;
      }
      return labels.some(label => {
        return label && label.indexOf(value) !== -1;
      });
    };
    const scrollToCurrent = () => {
      nextTick(() => {
        let currentNode = document.querySelector('.is-checked');
        if (currentNode) {
          if (currentNode.getBoundingClientRect().y > window.innerHeight) {
            scroll.value.setScrollTop(currentNode.getBoundingClientRect().y - 550);
          }
        }
      });
    };
    const setCheckedNodes = () => {
      treeRef.value.setCheckedNodes(props.defaultCheckNode, false);
      scrollToCurrent();
    };

    //设置选中node
    watch(() => {
      return props.defaultCheckNode;
    }, () => {
      setCheckedNodes();
    });
    onMounted(() => {
      setCheckedNodes();
    });

    // 点击树形节点
    let timeout = null;
    const handleNodeClick = val => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      } else {
        timeout = setTimeout(() => {
          // if (!val.children || !val.children.length) {
          emits('handleNodeClick', val);
          timeout = null;
          // } else {
          // 	timeout = null;
          // }
        }, 300);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_tree = _resolveComponent("el-tree");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.title ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
        modelValue: query.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => query.value = $event),
        placeholder: __props.placeholder,
        onInput: onQueryChanged
      }, {
        suffix: _withCtx(() => [_createElementVNode("span", {
          class: "search-icon iconfont icon-zhihui-sousuo",
          onClick: _cache[0] || (_cache[0] = $event => onQueryChanged(query.value))
        })]),
        _: 1
      }, 8, ["modelValue", "placeholder"])]), _createVNode(_component_el_scrollbar, {
        class: "scrollbar",
        ref_key: "scroll",
        ref: scroll
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tree, {
          ref_key: "treeRef",
          ref: treeRef,
          class: "filter-tree",
          "current-node-key": __props.currentNodeKey,
          "highlight-current": "",
          "node-key": __props.nodeKey,
          "check-strictly": true,
          data: __props.data,
          props: __props.defaultProps,
          "default-expand-all": __props.defaultExpand,
          "expand-on-click-node": __props.expandOnClickNode,
          "default-expanded-keys": [__props.defaultExendNode],
          "default-checked-keys": [__props.defaultCheckedKeys],
          "filter-node-method": filterNode,
          onNodeClick: handleNodeClick
        }, null, 8, ["current-node-key", "node-key", "data", "props", "default-expand-all", "expand-on-click-node", "default-expanded-keys", "default-checked-keys"])]),
        _: 1
      }, 512)]);
    };
  }
});